module.exports = __webpack_public_path__ + "static/media/23.c10dcde8.svg";